import { ProjectStatus } from '@constants/entities/project';
import useProjectData from '@hooks/useProjectData';

const useProjectArchived = (projectId?: string) => {
  const [{ status }] = useProjectData(projectId);
  return status === ProjectStatus.Archived;
};

export default useProjectArchived;
